import { render, staticRenderFns } from "./drawLots-list.vue?vue&type=template&id=5f8bbbb4&scoped=true&"
import script from "./drawLots-list.vue?vue&type=script&lang=js&"
export * from "./drawLots-list.vue?vue&type=script&lang=js&"
import style0 from "./drawLots-list.vue?vue&type=style&index=0&id=5f8bbbb4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8bbbb4",
  null
  
)

export default component.exports